import React, { Component } from "react";
import ReactDOM from "react-dom";
import rehypeRaw from "rehype-raw";
import ReactMarkdown from "react-markdown";
import { LogEvent } from "@learningblocks/shared-components";
import Skip from "./SkipIcon";
import { Tip } from "./Tip";

import { SimManager } from "@learningblocks/simulation-engine";

// Styles
import colors from "@learningblocks/protocol-constants/lib/Styles/_exports.module.scss";
import "./style.scss";

//Icons
import IconNotebook from "@learningblocks/protocol-constants/lib/Icons/notebook-solid";
import IconHexagon from "@learningblocks/protocol-constants/lib/Icons/hexagon-solid";

export class ProtocolTask extends Component {
  constructor(props) {
    super(props);

    this.state = {
      createNoteView: false,
      readNoteView: props.notes.length > 0 ? true : false,
      normalView: true,
      menuOpen: false,
      note: "",
    };
  }

  handleClick = (e) => {
    const domNode = ReactDOM.findDOMNode(this.node);

    if (domNode) {
      if (domNode.contains(e.target)) {
        //Click is inside component
        return;
      }
      // Click is outside component -- close the menu
      this.setState({
        menuOpen: false,
      });
    }
  };

  componentDidUpdate(prevProps) {
    if (this.props.page !== prevProps.page) {
      this.setState({
        createNoteView: false,
        readNoteView: false,
        normalView: true,
        menuOpen: false,
        note: "",
      });
    }

    if (prevProps.current !== this.props.current && this.props.current) {
      this.scrollToCurrent();
    }
  }

  componentWillMount() {
    document.body.addEventListener("mousedown", this.handleClick, false);
  }

  componentWillUnmount() {
    document.body.removeEventListener("mousedown", this.handleClick, false);
  }

  scrollToCurrent = () => {
    if (this.task && this.task.offsetTop != null) {
      const container = this.task.closest(".protocol-content");
      if (container) {
        container.scrollTo({
          top: this.task.offsetTop - 8,
          behavior: "smooth",
        });
        this.task.focus();
      }
    }
  };

  showNotesClicked = () => {
    this.setState({
      readNoteView: !this.state.readNoteView,
      menuOpen: false,
      createNoteView: false,
    });
  };

  createNoteClicked = () => {
    this.setState({
      createNoteView: !this.state.createNoteView,
      menuOpen: false,
      readNoteView: false,
      note: "",
    });
  };

  toggleMenu = () => {
    this.setState({
      readNoteView: false,
      createNoteView: false,
      menuOpen: !this.state.menuOpen,
    });
  };

  handleFormChange = (e) => {
    this.setState({
      note: e.target.value,
    });
  };

  handleFormSubmit = (e) => {
    e.preventDefault();

    this.setState({
      menuOpen: false,
      readNoteView: true,
      createNoteView: false,
      note: "",
    });

    this.props.saveTaskNote({
      note: this.state.note,
      page: this.props.page - 1,
      index: this.props.tIndex,
    });
  };

  renderTaskModalBtn = () => {
    let btn = "";

    if (this.props.wrong) {
      btn = (
        <LogEvent
          logEventProps={{
            sim_id: 1,
            sim_name: "diffusion-and-medicine",
            section: "protocol",
            level: 1,
            event_type: "sim_protocol_popup viewed",
            event_schema: "popup",
          }}
          actionProps={{ onClick: { action: "click" } }}
          elementType="button"
        >
          <button
            className={"task-button"}
            onClick={() => {
              SimManager.getInstance().customButtonFunction(
                "Restart " + this.props.taskID
              );
            }}
          >
            Restart step
          </button>
        </LogEvent>
      );
      return btn;
    }

    if (this.props.buttonText) {
      btn = (
        <LogEvent
          logEventProps={{
            sim_id: 1,
            sim_name: "diffusion-and-medicine",
            section: "protocol",
            level: 1,
            event_type: "sim_protocol_popup viewed",
            event_schema: "popup",
          }}
          actionProps={{ onClick: { action: "click" } }}
          elementType="button"
        >
          <button
            className={"task-button"}
            onClick={() => {
              SimManager.getInstance().customButtonFunction(
                this.props.buttonText
              );
            }}
          >
            {this.props.buttonText}
          </button>
        </LogEvent>
      );
      return btn;
    }

    if (this.props.modal === undefined) {
      return "";
    } else if (this.props.modal.type === undefined) {
      btn = (
        <LogEvent
          logEventProps={{
            sim_id: 1,
            sim_name: "using-a-spectrophotometer",
            section: "protocol",
            level: 1,
            event_type: "sim_protocol_popup viewed",
            event_schema: "popup",
            popup_type: this.props.modal.name,
          }}
          actionProps={{ onClick: { action: "click" } }}
          elementType="button"
        >
          <button
            className={"task-button"}
            onClick={() => {
              this.props.setModal({
                display: true,
                type: this.props.modal.name,
                size: "cover",
                connect: -1,
                data: this.props.modal,
              });
            }}
          >
            <ReactMarkdown
              rehypePlugins={[rehypeRaw]}
              components={{ p: React.Fragment }}
            >
              {this.props.modal.title.replace("\\_", "_")}
            </ReactMarkdown>
          </button>
        </LogEvent>
      );
      return btn;
    }
  };

  getAlphabetIndex = (index) => {
    if (index >= 26) {
      const upperIndex = Math.floor(index / 25);
      const delta = index - 25 * upperIndex;

      return (
        String.fromCharCode(96 + upperIndex) + String.fromCharCode(96 + delta)
      );
    }
    return String.fromCharCode(97 + index);
  };

  render() {
    return (
      <li
        className={
          "protocol-task" +
          (this.props.current ? " current-task" : "") +
          (this.props.complete ? " completed-task" : "") +
          (this.props.optional ? " optional-task" : "") +
          (this.props.wrong
            ? " wrong-task"
            : this.props.skipped
              ? " skipped-task"
              : "")
        }
        aria-label={`Task ${this.props.objectiveIndex + 1}.${this.getAlphabetIndex(this.props.stepIndex)}`}
        ref={(task) => {
          this.task = task;
        }}
      >
        <div className="protocol-task-wrapper">
          <div className="index">
            {this.props.wrong ? (
              <IconHexagon
                aria-hidden="true"
                style={{
                  color: colors.burgundy,
                  height: "29px",
                }}
              />
            ) : this.props.skipped ? (
              <Skip aria-hidden="true" />
            ) : (
              <IconHexagon
                aria-hidden="true"
                style={{
                  color: this.props.current
                    ? "white"
                    : this.props.complete
                      ? colors.navy3
                      : colors.navy1,
                  height: "29px",
                }}
              />
            )}
            {(!this.props.skipped || this.props.wrong) && (
              <span
                style={{
                  color: this.props.current ? colors.navy1 : "white",
                }}
              >
                {this.props.complete
                  ? " "
                  : this.getAlphabetIndex(this.props.stepIndex)}
              </span>
            )}
          </div>

          <span aria-label={this.props.aria} className="task-text">
            {this.props.optional && (
              <div className="optional-text">
                <b>
                  <i>OPTIONAL</i>
                </b>
              </div>
            )}
            <ReactMarkdown
              rehypePlugins={[rehypeRaw]}
              components={{
                p: ({ ...props }) => <>{props.children}</>,
              }}
            >
              {this.props.text.replace("\\_", "_")}
            </ReactMarkdown>
          </span>
          <span> </span>
          <button
            className="anchor"
            onClick={this.showNotesClicked}
            style={{
              display:
                !this.state.readNoteView && this.props.notes.length > 0
                  ? "initial"
                  : "none",
              cursor: "pointer",
            }}
          >
            <IconNotebook
              style={{
                color: colors.charcoal1,
                height: "15px",
                top: "2px",
              }}
            />
          </button>
          <div
            className="protocol-menu"
            ref={(node) => (this.node = node)}
          ></div>
        </div>
        {this.props.tip && <Tip tipTitle="Tip!" tip={this.props.tip} />}
        {this.props.note && <Tip tipTitle="Note:" tip={this.props.note} />}
        {this.renderTaskModalBtn()}
      </li>
    );
  }
}

ProtocolTask.defaultProps = {
  notes: [],
};
